(ns ui.editors.simple-filters.commit
  "When the value that a user types into a filter becomes a filter, and what the
   filter is. The rules are pure, so that they can be tested. The view calls them
   from its input handlers.

   A value becomes a filter when the user presses Enter, when the user leaves the
   input, when typing stops for `debounce-ms`, and when the user changes the
   operator or the currency while the filter has a value. Before, only leaving
   the input applied the value. A user who typed a number and pressed Enter saw
   no change, and the panel showed a condition that the list did not use."
  (:require
   [clojure.string :as string]))

(def debounce-ms
  "How long after the last key press the typed value is applied. A shorter time
   sends a query for each digit. A longer time looks like no reaction."
  500)

(def scalar-numeric-operators
  "The numeric operators that take one value. The between operator takes two."
  #{:operand/equals
    :operand/smaller-than
    :operand/greater-than})

(defn- blank-value?
  [value]
  (string/blank? (str value)))

(defn enter-key?
  "True for the key name of the Enter key, as `KeyboardEvent.key` gives it."
  [key-name]
  (= "Enter" key-name))

(defn scalar-selection
  "Return the selection for a filter with one value, for example `greater than
   100000`, or nil when the value is blank. `op-state` is the local state of the
   operator panel: `:op`, `:value` and `:currency`. The selection has a currency
   only for a currency field."
  [{:keys [op value currency]} currency-field?]
  (when-not (blank-value? value)
    {:kind     :value
     :operator op
     :currency (when currency-field? currency)
     :value    value
     :label    (str value)}))

(defn between-selection
  "Return the selection for a filter with two values, for example `between 10
   and 20`, or nil when one of the two values is blank. `op-state` is the local
   state of the operator panel: `:op`, `:from`, `:to` and `:currency`."
  [{:keys [op from to currency]}]
  (when-not (or (blank-value? from)
                (blank-value? to))
    {:kind     :value
     :operator op
     :from     from
     :to       to
     :currency currency
     :value    (str from " .. " to)
     :label    (str from " .. " to)}))

(defn operator-switch-selection
  "Return the selection to apply when the user switches to the numeric operator
   `op` and the panel already holds a value, or nil when there is nothing to
   apply yet. A scalar operator needs `:value`. The between operator needs both
   `:from` and `:to`. `op-state` is the local state with the new operator."
  [{:keys [op] :as op-state} currency-field?]
  (cond
    (contains? scalar-numeric-operators op)
    (scalar-selection op-state currency-field?)

    (= :operand/between-inclusive op)
    (between-selection op-state)

    :else
    nil))
